import { PostNetworkType, PostStats } from '@sprinklr/stories/post/Post';

export const getStatIcon = (stat: PostStats, snType: PostNetworkType): string => {
    switch (snType) {
        case 'twitter':
        case 'x':
            switch (stat) {
                case 'numRetweets':
                    return 'native_twitter_retweet';
                case 'numComments':
                    return 'native_twitter_comment';
                case 'numLikes':
                    return 'native_twitter_like';
            }
            break;
        case 'facebook':
            switch (stat) {
                case 'numLikes':
                    return 'native_facebook_like';
            }
            break;
        case 'instagram':
            switch (stat) {
                case 'numComments':
                    return 'native_twitter_comment';
                case 'numLikes':
                    return 'native_twitter_like';
            }
            break;
        case 'youtube':
            switch (stat) {
                case 'viewCount':
                    return 'preview';
                case 'numComments':
                    return 'native_twitter_comment';
                case 'numLikes':
                    return 'native_twitter_like';
            }
            break;
        default:
            switch (stat) {
                case 'viewCount':
                    return 'preview';
                case 'numRetweets':
                    return 'native_twitter_retweet';
                case 'numComments':
                    return 'native_twitter_comment';
                case 'numLikes':
                    return 'native_twitter_like';
            }
            break;
    }
};
